import script from "./RegisterConfirmationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterConfirmationView.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterConfirmationView.vue?vue&type=style&index=0&id=2fb0fa02&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb0fa02"]])

export default __exports__